import { render, staticRenderFns } from "./GraficosEstadisticas.vue?vue&type=template&id=fd60fc62&scoped=true"
import script from "./GraficosEstadisticas.vue?vue&type=script&lang=js"
export * from "./GraficosEstadisticas.vue?vue&type=script&lang=js"
import style0 from "./GraficosEstadisticas.vue?vue&type=style&index=0&id=fd60fc62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd60fc62",
  null
  
)

export default component.exports